export const THEORETICAL_MAX_PAYMENT = 999_999_999;

export interface PaymentLimits {
    tenantNameAbbreviated: string;
    achMax: number;
    achMin: number;
    ccMax: number;
    ccMin: number;
}

export function createPaymentLimits(instance?: Partial<PaymentLimits>) {
    const obj = <PaymentLimits>{
        tenantNameAbbreviated: '',
        achMax: THEORETICAL_MAX_PAYMENT,
        achMin: 0,
        ccMax: THEORETICAL_MAX_PAYMENT,
        ccMin: 0
    };

    if (instance) {
        Object.assign(obj, instance);
    }

    return obj;
}